import { motion } from 'framer-motion'
import { useSlideCopy } from '@/lib/i18n'
import type { SlideProps } from '@/components/SlideWizard'
import { copy } from './Slide9RecoveryScam.copy'

const ease = [0.16, 1, 0.3, 1] as const

export default function Slide9RecoveryScam(_props: SlideProps) {
  const c = useSlideCopy(copy)
  return (
    <div className="min-h-[60vh] flex flex-col items-center justify-center text-center px-4 mx-auto max-w-3xl">
      <motion.h2
        initial={{ opacity: 0, y: 14 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7, delay: 0.25, ease }}
        className="text-4xl sm:text-5xl font-semibold text-slate-900 tracking-tight leading-[1.1]"
      >
        {c.title}
      </motion.h2>

      <motion.p
        initial={{ opacity: 0, y: 14 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, delay: 0.55, ease }}
        className="mt-6 text-xl sm:text-2xl text-slate-500 leading-relaxed max-w-2xl"
      >
        {c.body}
      </motion.p>

      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.5, delay: 0.9, ease }}
        className="mt-10 max-w-md text-start"
      >
        <p className="text-xs uppercase tracking-[0.2em] text-slate-400 font-semibold">
          {c.listHeading}
        </p>
        <div className="mt-5 space-y-5">
          {c.items.map((item, i) => (
            <motion.div
              key={item.title}
              initial={{ opacity: 0, y: 6 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.4, delay: 1.0 + i * 0.12, ease }}
            >
              <p className="text-lg sm:text-xl font-semibold text-slate-900 leading-snug">
                {item.title}
              </p>
              <p className="mt-1 text-base sm:text-lg text-slate-500 leading-relaxed">
                {item.description}
              </p>
            </motion.div>
          ))}
        </div>
      </motion.div>

    </div>
  )
}
